import React, { useContext, useEffect, useRef, useState } from "react";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/heroKusama.scss";
import CustomButton from "../../CustomButton";
import SingleEmailForm2 from "../../Pieces/SingleEmailForm2";
import useWindowWidth from "../../../hooks/useBetterMediaQuery";
import SlicesVideoComponent from "../SlicesVideoComponent";
import { AnimatePresence, motion } from "framer-motion";
import HeroTurnerSlider from "./HeroTurnerSlider";
import { LogoMarquee } from "../LogosDali";
import Farrow from "../../../assets/icons/NewAnnotate/Farrow";

const HeroTurner = ({ slice, location }) => {
  const { toggleModal, setEmail } = useContext(ModalContext);

  return (
    <section className="relative px-4 bg-hero-turner mx-auto overflow-hidden sm:px-12 lg:px-5 max-w-7xl">
      <div className="flex flex-col gap-3.5 mx-auto">
        {slice?.primary?.banner_text?.text &&
        slice?.primary?.banner_link?.url ? (
          <a
            href={slice?.primary?.banner_link?.url}
            target="_blank"
            aria-label="opens in a new tab"
            className="bg-purple-2001 px-3.5 py-1.5 flex gap-2 text-sm sm:text-base font-medium leading-5 font-inter tracking-[-0.7px] items-center rounded-lg max-w-fit mx-auto "
          >
            <div
              className="text-gray-600 banner-text-strong-style"
              dangerouslySetInnerHTML={{
                __html: slice?.primary?.banner_text.html,
              }}
            />
            <Farrow styleClass="sm:w-auto w-5" />
          </a>
        ) : (
          slice?.primary?.banner_text?.text && (
            <div className="bg-purple-2001 px-3.5 py-1.5 flex gap-2 text-sm sm:text-base font-medium leading-5 font-inter tracking-[-0.7px] items-center rounded-lg max-w-fit mx-auto ">
              <div
                className="text-gray-600 banner-text-strong-style"
                dangerouslySetInnerHTML={{
                  __html: slice?.primary?.banner_text.html,
                }}
              />
              <Farrow styleClass="sm:w-auto w-5" />
            </div>
          )
        )}
        {slice?.primary?.hero_title?.text && (
          <h1
            role="heading"
            className={`text-3.25xl flex justify-center mx-auto hero_turner_strong_color_style sm:text-[60px] sm:max-w-[648px]  lg:max-w-[862px] text-center font-manrope leading-[40px]  sm:leading-[68px] !font-medium tracking-[-2.2px] sm:tracking-[-3px]`}
            dangerouslySetInnerHTML={{
              __html: slice?.primary?.hero_title?.html,
            }}
          />
        )}
        {slice?.primary?.descriptor_text?.text && (
          <p
            className={`sm:text-lg text-base leading-6 mx-auto sm:leading-7 max-w-[534px] text-center font-normal tracking-tight_1  font-inter`}
          >
            {slice?.primary?.descriptor_text?.text}
          </p>
        )}
        <div className="mx-auto lg:w-[470px] pt-6 pb-5">
          <SingleEmailForm2
            buttonText={slice?.primary?.cta_title?.text}
            openModal={toggleModal}
            setEmail={setEmail}
          />
        </div>

        {slice?.primary?.logos_caption_title?.text && (
          <p className="text-center uppercase text-gray-600 m-0 sm:text-sm text-2xs tracking-[0.07em]">
            {slice?.primary?.logos_caption_title?.text}
          </p>
        )}
        {Array.isArray(slice?.items) &&
          slice.items.some((item) => item?.logo?.url) && (
            <LogoMarquee logoArray={slice} />
          )}
      </div>

      <HeroTurnerSlider primary={slice} carouselData={slice?.items} />
    </section>
  );
};

export default HeroTurner;
